import React, { useEffect, useState } from 'react';
import { Row, Col, Card, Space, DatePicker, Drawer, Form, Input, Select, Radio, message, Modal, Pagination, Tabs } from 'antd';
import { Table, Button } from 'antd';
import BreadcrumbCustom from '../../components/widget/BreadcrumbCustom';
import { DownOutlined, ExclamationCircleOutlined, PlusOutlined } from '@ant-design/icons';
import { ITeachClass, listTeachClasss, createTeachClass, updateTeachClass, enableTeachClass, pageTeachClasss } from '../../service/api/teachClass';
import moment from 'moment';
import { ITeacher, listTeachers } from '../../service/api/teacher';
import { FormInstance } from 'antd/lib/form/Form';
import { IStore, listStores } from '../../service/api/store';
import './css.less';
const { confirm } = Modal;
const { Option } = Select;

interface ITeachClassListProps {
  visible: boolean
  setVisible: (visible: boolean) => void;
  filterStoreIds: number[] | undefined
  searchKeyword: string | undefined
}
const TeachClassList: React.FC<ITeachClassListProps> = ({
  visible,
  setVisible,
  filterStoreIds,
  searchKeyword,
}) => {
  const [teachClasss, setTeachClasss] = useState<ITeachClass[]>();
  const [teachers, setTeachers] = useState<ITeacher[]>();
  const [stores, setStores] = useState<IStore[]>();
  const [teachClassDetail, setTeachClassDetail] = useState<ITeachClass>();
  const [pageNum, setPageNum] = useState(1);
  const [pageTotal, setPageTotal] = useState(1);
  const [pageSize, setPageSize] = useState(20);
  const [loading, setLoading] = useState(false);
  const formRef = React.createRef<FormInstance>();

  const columns = [
    {
      title: '名称',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: '负责老师',
      dataIndex: 'teacherName',
      key: 'teacherName',
    },
    {
      title: '备注',
      dataIndex: 'remark',
      key: 'remark',
    },
    {
      title: '学员数量',
      dataIndex: 'studentCount',
      key: 'studentCount',
    },
    {
      title: '课程完成情况',
      dataIndex: 'courseCount',
      key: 'courseCount',
      render: (text: any, record: any) => {
        return record.courseFinishCount + "/" + record.courseCount;
      }
    },
    {
      title: '所属门店',
      width: 180,
      dataIndex: 'storeName',
      key: 'storeName',
    },
    {
      title: '状态',
      dataIndex: 'enable',
      key: 'enable',
      render: (text: any, record: any) => {
        if (record.enable) {
          return <span style={{ color: 'green' }}>进行中</span>
        } else {
          return <span style={{ color: 'grey' }}>已停用</span>
        }
      }
    },
    {
      title: '操作',
      key: 'action',
      render: (text: any, record: any) => {
        if (record.enable) {
          return <Space size="middle">
            <a onClick={() => {
              setTeachClassDetail(record);
              setVisible(true);
            }}>编辑 </a>
            <a target="_blank" href={'#/app/schedule/teachClass/student?teachClassId=' + record.id + '&&teachClassName=' + encodeURI(record.name) + '&&storeId=' + record.storeId} >班级学员 </a>
            <a target="_blank" href={'#/app/schedule/teachClass/course?teachClassId=' + record.id + '&&teacherId=' + record.teacherId + '&&teachClassName=' + record.name + '&&storeId=' + record.storeId} >课程安排 </a>
            <a onClick={e => { onEnable(e, record) }}>停用 </a>
          </Space>
        } else {
          return <Space size="middle">
            <a onClick={() => {
              setTeachClassDetail(record);
              setVisible(true);
            }}>编辑 </a>
            <a target="_blank" href={'#/app/schedule/teachClass/student?teachClassId=' + record.id + '&&teachClassName=' + encodeURI(record.name) + '&&storeId=' + record.storeId} >班级学员 </a>
            <a target="_blank" href={'#/app/schedule/teachClass/course?teachClassId=' + record.id + '&&teacherId=' + record.teacherId + '&&teachClassName=' + record.name + '&&storeId=' + record.storeId} >课程安排 </a>
            <a onClick={e => { onEnable(e, record) }}>启用 </a>
          </Space>
        }
      },
    }
  ];

  useEffect(() => {
    loadData();
  }, [pageNum, pageSize, filterStoreIds, searchKeyword]);

  useEffect(() => {
    if (teachClassDetail) {
      // 设置100毫秒的延迟 确保from组件已经加载完毕
      setTimeout(() => {
        formRef.current!.setFieldsValue(teachClassDetail);
      }, 100);
    }
  }, [teachClassDetail]);

  // const xx = ()=>{
  //   return <div>
  //   <Select placeholder="全部校区"
  //     style={{ minWidth: 180, marginLeft: '10px' }} mode="multiple"
  //     onChange={(value: any) => {
  //       setFilterStoreIds(value);
  //     }}
  //   // allowClear
  //   >
  //     {storeOptions}
  //   </Select>
  //   <Input type='text' placeholder="请输入姓名" style={{ width: 160, marginLeft: '10px' }}
  //     onChange={onSearchKeyword} allowClear>
  //   </Input>
  //   <Button type="ghost" style={{ width: 100, marginLeft: '10px' }} icon={<SearchOutlined />} onClick={() => {
  //     loadData();
  //   }}>搜索</Button>
  //   <Button type="primary" onClick={() => {
  //     setTeachClassVisible(true);
  //   }} icon={<PlusOutlined />}>
  //     新增班级
  //   </Button>
  // </div>
  // }

  const loadData = () => {
    pageTeachClasss(pageNum, pageSize, filterStoreIds || '',searchKeyword || '').then((info: any) => {
      setTeachClasss(info?.data.list);
      setPageTotal(info?.data.total);
      // console.log("info:" + JSON.stringify(info.data));
    });
    listTeachers().then((info: any) => {
      setTeachers(info?.data);
    });
    listStores().then((info: any) => {
      setStores(info?.data);
    });
  }

  const onFinish = (values: any) => {
    setLoading(true);
    if (teachClassDetail) {
      updateTeachClass({
        ...values,
        id: teachClassDetail.id
      }).then((info: any) => {
        console.log("info:" + JSON.stringify(info));
        if (info) {
          message.success("更新成功");
          onClose();
          setLoading(false);
          loadData();
        }
      });
    } else {
      createTeachClass(values).then((info: any) => {
        if (info) {
          console.log("info:" + JSON.stringify(info));
          if (info) {
            message.success("创建成功");
            onClose();
            setLoading(false);
            loadData();
          }
        }
      });
    }
  };


  const onEnable = (e: any, item: ITeachClass) => {
    e.stopPropagation();
    confirm({
      title: '提示',
      icon: <ExclamationCircleOutlined />,
      content: item.enable ? '确定要停用该班级吗？停用后无法被选到' : '确定要启用该班级吗？',
      okText: '确定',
      okType: 'danger',
      cancelText: '取消',
      onOk() {
        enableTeachClass(item.id, !item.enable).then((info: any) => {
          if (info) {
            message.success("操作成功");
            loadData();
          }
        });
      },
      onCancel() {
      },
    });
  }

  const onClose = () => {
    setTeachClassDetail(undefined);
    setVisible(false);
    if (formRef.current) {
      formRef.current!.resetFields();
    }
  }

  const onPageChange = (pageNum: number, pageSize?: number) => {
    console.log("pageNum:" + pageNum);
    console.log("pageSize:" + pageSize);
    setPageNum(pageNum);
    setPageSize(pageSize || 10);
    // setPageSize(info.data.pageSize);
  }

  // 下拉框值
  const storeOptions = stores?.map((store) =>
    <Option key={store.id} value={store.id}>{store.name}</Option>);

  // 下拉框值
  const teacherOptions = teachers?.map((teacher) =>
    <Option key={teacher.id} value={teacher.id}>{teacher.name}</Option>);

  return (
    <Card bordered={false}>
      <Table dataSource={teachClasss} columns={columns} pagination={false} 
      rowClassName={(record, index) => {
        if (record.enable) {
          return 'teachClassValid';
        } else {
          return 'teachClassInvalid';
        }
      }}
      />
      <div style={{ display: "flex", justifyContent: "flex-end", paddingTop: "10px" }}>
        <Pagination
          defaultCurrent={pageNum}
          total={pageTotal}
          pageSize={pageSize}
          hideOnSinglePage={false}
          className="pagination"
          onChange={onPageChange}
          showSizeChanger
          showTotal={total => `共计 ${total} 条`}
        />
      </div>
      <Drawer
        title={teachClassDetail ? "编辑班级" : "新增班级"}
        visible={visible}
        width={720}
        onClose={onClose}
        bodyStyle={{ paddingBottom: 80 }}
        destroyOnClose
      >
        <Form onFinish={onFinish} ref={formRef} layout="vertical" hideRequiredMark>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                name="name"
                label="名称"
                rules={[{ required: true, message: '请输入名称' }]}
              >
                <Input placeholder="请输入名称" />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="teacherId"
                label="负责教师"
                rules={[{ required: true, message: '请选择负责教师' }]}
              >
                <Select placeholder="请选择教师"  >
                  {teacherOptions}
                </Select>
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                name="storeId"
                label="门店"
                rules={[{ required: true, message: '请选择门店' }]}
              >
                <Select disabled={teachClassDetail ? true : false} placeholder="请选择门店"  >
                  {storeOptions}
                </Select>
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="remark"
                label="备注"
                rules={[{ required: true, message: '请输入备注' }]}
              >
                <Input placeholder="请输入备注" />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={24}>
              <Form.Item>
                <Button type="primary" htmlType="submit" loading={loading}>保存</Button>
                <Button htmlType="button" onClick={onClose}>取消</Button>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Drawer>
    </Card>
  );
};

export default TeachClassList;
